export const MARKETS = [
    { value: 'BR', label: 'Brasil' },
    { value: 'HK', label: 'Hong Kong' },
    { value: 'ID', label: 'Indonesia' },
    { value: 'MY', label: 'Malaysia' },
    { value: 'MX', label: 'Mexico' },
    { value: 'PH', label: 'Philippines' },
    { value: 'SG', label: 'Singapore' },
    { value: 'TW', label: 'Taiwan' },
    { value: 'TH', label: 'Thailand' },
    { value: 'US', label: 'United States' },
    { value: 'VN', label: 'Vietnam' },
];
export const BRASIL_SERVICE_TYPES = [
    { value: 'LALAGO', label: 'LALAGO' },
    { value: 'LALAPRO', label: 'LALAPRO' },
    { value: 'MPV', label: 'MPV/SUV' },
    { value: 'UV_FIORINO', label: 'UV / Utilitário' },
    { value: 'TRUCK330', label: 'Truck / Carreto' },
    { value: 'CAR', label: 'Sedan' },
];
export const HONG_KONG_SERVICE_TYPES = [
    { value: 'WALKER', label: 'Courier' },
    { value: 'MOTORCYCLE', label: 'Motorcycle' },
    { value: 'VAN', label: 'Van' },
    { value: 'UV_FIORINO', label: '5.5 Ton' },
];
export const INDONESIA_SERVICE_TYPES = [
    { value: 'MOTORCYCLE', label: 'Motor' },
    { value: 'SEDAN', label: 'Sedan' },
    { value: 'MPV', label: 'Mobil' },
    { value: 'TRUCK175', label: 'Van' },
    { value: 'VAN', label: 'Pickup Bak' },
];
export const MALAYSIA_SERVICE_TYPES = [
    { value: 'MOTORCYCLE', label: 'Motorcycle / Motosikal' },
    { value: 'CAR', label: 'Car / Kereta' },
    { value: 'VAN', label: 'Van' },
    { value: '4X4', label: '4X4' },
    { value: 'TRUCK330', label: '1-Ton Lorry / Lori 1-Tan' },
    { value: 'TRUCK550', label: '3-Ton Lorry / Lori 3-Tan' },
];
export const MEXICO_SERVICE_TYPES = [
    { value: 'MOTORCYCLE', label: 'Motorcycle/Moto' },
    { value: 'MPV', label: 'MPV/SUV' },
    { value: 'UV_FIORINO', label: 'Minivan/Camioneta' },
    { value: 'TRUCK330', label: 'Truck/Camión' },
];
export const PHILIPPINES_SERVICE_TYPES = [
    { value: 'MOTORCYCLE', label: 'Motorcycle' },
    { value: 'MPV', label: 'UV (Small)' },
    { value: 'VAN', label: 'Van' },
    { value: 'TRUCK330', label: 'FB/L300' },
];
export const SINGAPORE_SERVICE_TYPES = [
    { value: 'MOTORCYCLE', label: 'Bike' },
    { value: 'CAR', label: 'Car' },
    { value: 'MINIVAN', label: '1.7m Van' },
    { value: 'VAN', label: '2.4m Van' },
    { value: 'TRUCK330', label: '10ft Lorry' },
    { value: 'TRUCK550', label: '14ft Lorry' },
];
export const TAIWAN_SERVICE_TYPES = [
    { value: 'MOTORCYCLE', label: 'Motorcycle' },
    { value: 'MPV', label: 'SUV' },
    { value: 'VAN', label: 'VAN' },
    { value: 'TRUCK175', label: 'Truck' },
];
export const THAILAND_SERVICE_TYPES = [
    { value: 'MOTORCYCLE', label: 'Motorcycle' },
    { value: 'CAR', label: 'Sedan' },
    { value: 'SUV', label: 'SUV' },
    { value: 'MPV', label: 'Hatchback' },
    { value: 'TRUCK330', label: 'Box Truck' },
    { value: 'TRUCK175', label: 'Fence Truck' },
    { value: 'PICK_UP_TRUCK', label: 'Pick-Up Truck' },
];
export const UNITED_STATES_SERVICE_TYPES = [
    { value: 'CAR', label: 'Sedan' },
    { value: 'VAN', label: 'Cargo Van' },
    { value: 'MPV', label: 'SUV' },
    { value: 'TRUCK330', label: 'Pickup Truck' },
];
export const VIET_NAM_SERVICE_TYPES = [
    { value: 'MOTORCYCLE', label: 'Motorcycle' },
    { value: 'VAN', label: 'Van 500kg' },
    { value: 'VAN_1000', label: 'Van 1000kg' },
    { value: 'TRUCK175', label: 'Truck 500kg' },
    { value: 'TRUCK330', label: 'Truck 1000kg' },
    { value: 'TRUCK550', label: 'Truck 2000kg' },
    { value: 'PICK_UP_TRUCK', label: 'Pickup Truck' },
];
//# sourceMappingURL=markets.js.map